import { Card, ECardBorderRadiusSize } from '@outdoorsyco/bonfire';
import React from 'react';

import { IWishlistingEventData } from '@/services/analytics/listings/types';
import { IBundleTile } from '@/utility/mapSearchResultToTile';

import { EscapeTileCarousel } from './EscapeTileCarousel';
import { EscapeTileContent } from './EscapeTileContent';

type TEscapeTileProps = {
  bundle: IBundleTile;
  wishlistingEventData?: IWishlistingEventData;
  showCTA?: boolean;
  isOutlined?: boolean;
  trackClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick?: () => void;
};

export const EscapeTile = ({
  bundle,
  wishlistingEventData,
  showCTA = true,
  isOutlined,
  trackClick,
  onMouseEnter,
  onMouseLeave,
  onClick,
}: TEscapeTileProps) => {
  const { name, location, lowestPrice, presentmentCurrency, slug } = bundle;

  return (
    <div
      className="md:h-1/2"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={trackClick}>
      <Card
        borderRadiusSize={ECardBorderRadiusSize.Large}
        withBoxShadow={false}
        withTransparentBackground>
        <EscapeTileCarousel
          bundle={bundle}
          wishlistingEventData={wishlistingEventData}
          isOutlined={isOutlined}
          onClick={onClick}
        />
        <EscapeTileContent
          location={location}
          name={name}
          lowestPrice={lowestPrice}
          presentmentCurrency={presentmentCurrency}
          slug={slug}
          showCTA={showCTA}
          onClick={onClick}
        />
      </Card>
    </div>
  );
};
